module.exports = __webpack_public_path__ + "static/media/SAM_1300.e00b6dbe.JPG";